function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { InMemoryCache } from "@apollo/client";
import * as Sentry from "@sentry/core";
import merge from "lodash/merge";
import pickBy from "lodash/pickBy";
import { v4 as uuid } from "uuid";
import apolloPossibleTypes from "@oui/lib/src/types/apollo-types.generated";
import { makeClient } from "./apollo";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var merger = {
    merge: function merge(existing, incoming, param) {
        var mergeObjects = param.mergeObjects;
        return mergeObjects(existing, incoming);
    }
};
// https://github.com/dotansimha/graphql-code-generator/issues/5025
var typePolicies = {
    Query: {
        fields: {
            ouiUser: function ouiUser(_, param) {
                var toReference = param.toReference;
                return toReference({
                    __typename: 'CurrentOuiUser'
                });
            },
            patientByPatientID: function patientByPatientID(_, param) {
                var args = param.args, toReference = param.toReference;
                return toReference({
                    __typename: 'PatientProfile',
                    patient: {
                        ID: args === null || args === void 0 ? void 0 : args.patientID
                    }
                });
            },
            hopeKitItems: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                merge: function merge() {
                    var existing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], incoming = arguments.length > 1 ? arguments[1] : void 0;
                    return incoming !== null && incoming !== void 0 ? incoming : existing;
                }
            }
        }
    },
    ActivityEvent: {
        keyFields: [
            'activityEventID'
        ]
    },
    ActivityEventInstance: {
        keyFields: [
            'activityEventInstanceID'
        ]
    },
    KVResponse: {
        keyFields: [
            'context',
            'key'
        ]
    },
    Organization: {
        keyFields: [
            'ID'
        ]
    },
    Composition: {
        keyFields: [
            'ID'
        ]
    },
    CompositionSection: {
        keyFields: [
            'ID'
        ]
    },
    CurrentOuiUser: {
        keyFields: []
    },
    UserEntity: {
        keyFields: [
            'ID'
        ]
    },
    LegacyUser: {
        keyFields: [
            'ID'
        ],
        fields: {
            name: merger,
            demo: merger,
            address: merger
        }
    },
    PatientProfile: {
        // TODO now we have ID directly on PatientProfile, we should add it to all existing queries
        // and then update the keyFields to ['ID']
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        keyFields: [
            'patient',
            [
                'ID'
            ]
        ],
        fields: {
            progress: {
                merge: function merge(existing, incoming) {
                    return incoming !== null && incoming !== void 0 ? incoming : existing;
                }
            }
        }
    },
    YstProfile: {
        keyFields: [
            'ID'
        ]
    },
    OuiAdmin: {
        keyFields: [
            'ID'
        ],
        fields: {
            person: merger
        }
    },
    Practitioner: {
        keyFields: [
            'ID'
        ],
        fields: {
            person: merger
        }
    },
    Role: {
        keyFields: [
            'ID'
        ],
        fields: {
            productConfig: {
                merge: function merge1(existing, incoming) {
                    return merge({}, existing, incoming);
                }
            },
            progress: {
                merge: function merge(existing, incoming) {
                    return incoming !== null && incoming !== void 0 ? incoming : existing;
                }
            }
        }
    },
    Patient: {
        keyFields: [
            'ID'
        ],
        fields: {
            person: merger
        }
    },
    PatientSupporter: {
        keyFields: [
            'supporterID',
            'patientID'
        ]
    },
    Practice: {
        keyFields: [
            'practiceID'
        ],
        fields: {
            practiceValues: merger
        }
    },
    SleepDiaryEntryPractice: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        keyFields: [
            'practiceValues',
            [
                'date'
            ]
        ],
        fields: {
            practiceValues: merger
        }
    },
    WordPairingPractice: {
        keyFields: [
            'practiceID'
        ],
        fields: {
            practiceValues: merger,
            wordPairing: merger
        }
    },
    FileUpload: {
        keyFields: [
            'fileUploadID'
        ]
    },
    HopeKitImage: {
        keyFields: [
            'hopeKitItemID'
        ]
    },
    HopeKitVideo: {
        keyFields: [
            'hopeKitItemID'
        ]
    },
    HopeKitQuote: {
        keyFields: [
            'hopeKitItemID'
        ]
    },
    CMSSession: {
        keyFields: [
            'sessionID'
        ]
    },
    CMSExchange: {
        keyFields: [
            'exchangeID'
        ]
    },
    CMSApp: {
        keyFields: [
            'appID'
        ]
    },
    CMSVariant: {
        keyFields: [
            'variantID'
        ]
    },
    OrganizationMember: {
        // TODO since a user can belong to multiple organizations, userID isn't necessarily unique.
        // Need organizationID too once added to API
        keyFields: [
            'userID'
        ],
        fields: {
            person: merger
        }
    },
    QuizSetCollection: {
        keyFields: [
            'quizSetCollectionID'
        ]
    },
    QuizSet: {
        keyFields: [
            'quizSetID'
        ],
        fields: {
            items: {
                merge: function merge(existing, incoming) {
                    return incoming !== null && incoming !== void 0 ? incoming : existing;
                }
            },
            legacyItems: {
                merge: function merge(existing, incoming) {
                    return incoming !== null && incoming !== void 0 ? incoming : existing;
                }
            }
        }
    },
    QuizSetItemVideo: {
        keyFields: [
            'quizSetItemID'
        ]
    },
    QuizSetItemChoice: {
        keyFields: [
            'quizSetItemID'
        ]
    },
    YstNomination: {
        fields: {
            status: merger
        }
    }
};
export var createApolloCacheBase = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, addTypename = _ref.addTypename, _ref_cacheClass = _ref.cacheClass, cacheClass = _ref_cacheClass === void 0 ? InMemoryCache : _ref_cacheClass;
    return new cacheClass({
        addTypename: addTypename !== null && addTypename !== void 0 ? addTypename : true,
        possibleTypes: apolloPossibleTypes.possibleTypes,
        typePolicies: typePolicies,
        dataIdFromObject: function(object) {
            if (object.__typename && object.ID) return "".concat(object.__typename, ":").concat(object.ID);
            if (object.ID) return "".concat(object.ID);
            if (object.__typename) {
                // if ID isn't the primary key, try {__typename}ID with correct casing
                var guessedIDKey = "".concat(object.__typename[0].toLowerCase()).concat(object.__typename.slice(1), "ID");
                if (object[guessedIDKey]) return "".concat(object.__typename, ":").concat(object[guessedIDKey]);
            }
            return undefined;
        }
    });
};
export var createApolloClientBase = function(param) {
    var uri = param.uri, _param_cache = param.cache, cache = _param_cache === void 0 ? createApolloCacheBase() : _param_cache, baseClass = param.baseClass, clientLocale = param.clientLocale, clientName = param.clientName, clientTimezone = param.clientTimezone, clientVersion = param.clientVersion, _param_connectToDevTools = param.connectToDevTools, connectToDevTools = _param_connectToDevTools === void 0 ? false : _param_connectToDevTools, _param_defaultOptions = param.defaultOptions, defaultOptions = _param_defaultOptions === void 0 ? {} : _param_defaultOptions, _getAuthHeader = param.getAuthHeader, isProduction = param.isProduction, onLogout = param.onLogout, subscriptionUri = param.subscriptionUri;
    var logoutPromise = null;
    var client = makeClient({
        isProduction: isProduction,
        baseClass: baseClass,
        connectToDevTools: connectToDevTools,
        cache: cache,
        defaultOptions: merge({
            mutate: {},
            query: {
                fetchPolicy: 'network-only'
            },
            watchQuery: {
                fetchPolicy: 'cache-and-network',
                // We want to rely on the cache when a component re-renders (not remounts) rather
                // than send a new network request on every render after a mutation that touched the cached object
                // https://github.com/apollographql/apollo-client/issues/6760#issuecomment-668188727
                nextFetchPolicy: 'cache-first'
            }
        }, defaultOptions),
        uri: uri,
        subscriptionOptions: !subscriptionUri || process.env.NODE_ENV === 'test' ? undefined : {
            uri: subscriptionUri,
            connectionParams: /*#__PURE__*/ _async_to_generator(function() {
                var _tmp;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                _getAuthHeader()
                            ];
                        case 1:
                            return [
                                2,
                                (_tmp.Authorization = _state.sent(), _tmp)
                            ];
                    }
                });
            })
        },
        request: /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(operation) {
                var authHeader, _operation_getContext;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _getAuthHeader()
                            ];
                        case 1:
                            authHeader = _state.sent();
                            if (authHeader) {
                                ;
                                operation.setContext({
                                    headers: _object_spread_props(_object_spread({}, (_operation_getContext = operation.getContext()) === null || _operation_getContext === void 0 ? void 0 : _operation_getContext.headers), {
                                        authorization: authHeader
                                    })
                                });
                            }
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            operation.setContext(function(currentContext) {
                                return {
                                    headers: pickBy(_object_spread({
                                        'X-Oui-Client': clientName,
                                        'X-RequestID': uuid(),
                                        'X-Oui-Client-Version': clientVersion,
                                        'X-Client-Timezone': clientTimezone,
                                        'X-Client-Locale': clientLocale
                                    }, currentContext.headers), function(v) {
                                        return v !== null && typeof v !== 'undefined';
                                    })
                                };
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(operation) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(param) {
            var graphQLErrors = param.graphQLErrors, networkError = param.networkError, operation = param.operation;
            if (graphQLErrors) {
                graphQLErrors.forEach(function(error) {
                    var _extensions_exception;
                    var message = error.message, locations = error.locations, path = error.path, extensions = error.extensions;
                    if ((extensions === null || extensions === void 0 ? void 0 : (_extensions_exception = extensions.exception) === null || _extensions_exception === void 0 ? void 0 : _extensions_exception.extendedMessage) === 'INVALID_TOKEN' || // @ts-expect-error
                    (error === null || error === void 0 ? void 0 : error.extendedMessage) === 'INVALID_TOKEN') {
                        if (!logoutPromise) {
                            logoutPromise = onLogout({
                                apollo: client,
                                // This should, in theory, come from LogoutContext to make sure that we don't
                                // refetch queries during our logout, but since this specific logout behavior is
                                // really an edge case when a user's token is already invalid, we don't really
                                // get much by implementing setIsLoggingOut faithfully
                                // Original issue: https://github.com/ouihealth/oui-aviva/commit/413e7deca5c0369718fc66d9ef3f235b1530881c
                                setIsLoggingOut: function() {}
                            });
                            logoutPromise.then(function() {
                                logoutPromise = null;
                            }).catch(function() {
                                logoutPromise = null;
                            });
                        }
                    }
                    var bodyStr = message.split('body: ')[1];
                    if (bodyStr && bodyStr.startsWith('{')) {
                        // @ts-expect-error
                        error.body = JSON.parse(bodyStr);
                    }
                    var requestID = operation.getContext().headers['X-RequestID'];
                    var extra = isProduction ? {
                        requestID: requestID
                    } : {
                        requestID: requestID,
                        error: error,
                        originalError: error.originalError,
                        operationName: operation.operationName
                    };
                    Sentry.captureMessage("[GraphQL error]: Message: ".concat(message, ", Location: ") + "".concat(locations, ", Path: ").concat(path), {
                        extra: extra
                    });
                });
            }
            if (networkError) {
                Sentry.captureException(networkError);
            }
        }
    });
    return client;
};
